import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_AUTH } from '../routes/paths';
// components
import LoadingScreen from '../components/LoadingScreen';

AuthProtect.propTypes = {
  children: PropTypes.node
};

export default function AuthProtect({ children }) {
  const { isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (localStorage.getItem('lastVisitedPath') === '/auth/login') {
      localStorage.setItem('lastVisitedPath', '/dashboard/app');
    } else {
      const isProtectedRoute = location.pathname.startsWith('/dashboard');
      if (isProtectedRoute) {
        localStorage.setItem(
          'lastVisitedPath',
          location.pathname + location.search
        );
      }
    }

    return <Navigate to={PATH_AUTH.login} replace />;
  }

  return <>{children}</>;
}
